<template>
    <div class="content main-container">
        <div class="btn-item">
            <Button type="primary" @click="$refs.add.open({baseName:$route.query.name,baseId:$route.query.id})">新增</Button>
            <Button ghost type="primary" @click="pageBack">返回</Button>
        </div>

        <div class="table-box">
            <loading :isShow="loading" />
            <Table :columns="columns" :data="tableList">
                <template slot-scope="{ row }" slot="action">
                    <span class="table-btn" :class="{'disabled':row.isEffective == 1}"  @click="$refs.add.open(row)">编辑</span>
                </template>
                <template slot-scope="{ row }" slot="createTime">
                    <span>{{ row.createTime | filterTime('YYYY/MM/DD') }}</span>
                </template>
            </Table>
        </div>
        <div class="pageBox">
            <Page :total="allData.total" :current="search.pageNo" :page-size="allData.size" show-total
                @on-change="pageChange" style="text-align: center" />
        </div>

        <!-- 新增 -->
        <addRankInterests ref="add" :initList="getList"></addRankInterests>
    </div>
</template>
<script>
import { common } from '@/api/mixins';
import addRankInterests from './components/addRankInterests.vue';
export default {
    mixins: [common],
    components: { addRankInterests },
    data() {
        return {
            search: {
                baseId: '',
                pageNo: 1,
                pageSize: 10
            },
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            loading: false,
            columns: [
                {
                    title: '序号',
                    type: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: '基本法名称',
                    key: 'baseName',
                    minWidth: 200,
                    align: 'center'
                },
                {
                    title: '职级名称',
                    key: 'rankName',
                    width: 200,
                    align: 'center'
                },
                {
                    title: '利益项',
                    key: 'commissionName',
                    minWidth: 300,
                    align: 'center'
                },
                {
                    title: '创建时间',
                    slot: 'createTime',
                    width: 200,
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 120,
                    align: 'center'
                }
            ],
            tableList: [],
            allData: {},
            id: ''
        };
    },

    created() {
        this.search.baseId = this.$route.query.id;
        this.getList();
    },

    methods: {
        // 基本法列表
        getList(index) {
            if (index) {
                this.search.pageNo = index;
            }
            this.loading = true;
            this.$http({
                url: '/buz/baseCommissionJoin/read/list',
                type: 'POST',
                data: this.search
            })
                .then(res => {
                    this.loading = false;
                    this.allData = res;
                    this.tableList = res.data;
                })
                .catch(e => {
                    this.loading = false;
                });
        },

        // 分页
        pageChange(index) {
            this.search.pageNo = index;
            this.getList();
        },

        // 返回
        pageBack() {
            const fullPath = this.$route && this.$route.fullPath;
            window.parent.postMessage(
                {
                    removePageTag: fullPath,
                    appMessage: true
                },
                '*'
            );
            setTimeout(() => {
                this.openPageTabTags('/basicLawNew/config', {});
            }, 200);
        }
    }
};
</script>
<style lang="scss" scoped>
.btn-item {
    margin-bottom: 10px;
    text-align: right;
}
.disabled {
    pointer-events: none;
    color: #c5c8ce;
}
</style>
